import React, { Component } from 'react';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';
import OpcionDefecto from '../../../../../Common/Components/OpcionDefecto';
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const PreEmisionCabal = ({ data, selectCheckBox, selectRadio, selectCombo }) => {
    const arrayAux = data.GET_SENAL_PRE_EMISION_CABAL.filter(d => d.Checked);
    let acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");
    let acentoLetraAminuscula = ExpHelper.ConvertirCaracter("a");
    let letraNminuscula = ExpHelper.ConvertirCaracter("n");
    let e;

    let haySeleccion = false

    if(data.HabilitarSenalPreEmision){
        if(arrayAux[0] && arrayAux[0].Id){
            haySeleccion = true
            if(arrayAux.some(e=>e.Id==2 && e.Checked)){
                haySeleccion = data.GET_PRE_EMISION_CABAL.some(e=>e.Checked)
            }
        }else{
            haySeleccion = false
        }
    }

    return (
        
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Pre Emisi" + acentoLetraOminuscula + "n"}</label>
                <div className="container-radio radio-margin">

                    <CheckDefecto nombre={"Se" + letraNminuscula + "al de Pre-Emisi" + acentoLetraOminuscula + "n"}
                        referencia={"HabilitarSenalPreEmision"}
                        check={data.HabilitarSenalPreEmision}
                        selectCheckBox={({ target }) => selectCheckBox("HabilitarSenalPreEmision", target.checked)} />

                    <div className="row">

                        {data.HabilitarSenalPreEmision && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                            {data.GET_SENAL_PRE_EMISION_CABAL.map( ( item ) => {
                                const referencia = `GSPEC-${item.Id}`;

                                return (
                                    <CheckDefecto
                                        key={item.Id}
                                        nombre={item.Descripcion}
                                        check={item.Checked}
                                        activo={item.Activo}
                                        referencia={referencia}
                                        selectCheckBox={( event ) => {
                                            if ( data.HabilitarSenalPreEmision ) {
                                                selectCheckBox( "PreEmitida", item.Id, event.target.checked );
                                            }
                                        }}
                                    >



                                        {( item.Id == 2 ) &&

                                            <div className="left-separator-md">
                                                {data.GET_PRE_EMISION_CABAL.map( ( item ) => {
                                                    const id = `PRMC-${item.Id}`;
                                                    const classRadio = `container-radio${( ( !data.PreEmitida ) ? "-disabled" : "" )} radio-margin`;

                                                    return (
                                                        <div className={classRadio} key={item.Id}>
                                                            <div className="row">
                                                                <div className="col-xs-4">
                                                                    <div style={{ clear: "both" }}>
                                                                        <div style={{ float: "left", marginRight: "15px" }}>
                                                                            <input
                                                                                id={"preemi-" + id}
                                                                                type="radio"
                                                                                name="PermiteActivacionTelefonica"
                                                                                value={item.Codigo}
                                                                                checked={item.Checked && data.PreEmitida}
                                                                                data-codigo={item.Codigo}
                                                                                onChange={( event ) => {
                                                                                    if ( data.PreEmitida ) {
                                                                                        selectRadio( "GET_PRE_EMISION_CABAL", event.target.value, event.target.dataset.codigo )
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <label className="lbl-radio label-secondary" htmlFor={"preemi-" + id}>{item.Descripcion}</label>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                } )}

                                            </div>
                                        }
                                    </CheckDefecto>

                                )
                            } )
                            }
                        </div>}
                    </div>
                </div>
            </div>

            < div className="col-xs-12" >
            {data.HabilitarSenalPreEmision && <OpcionDefecto
                    infoData={arrayAux}
                    referencia={"PreEmisionDefaultId"}
                    valorCombo={data.PreEmisionDefaultId}
                    valorChecked={data.PreEmisionDefaultInterfaz}
                    selecciono={haySeleccion}
                    selectCombo={(value) => selectCombo("PreEmisionDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("PreEmisionDefaultInterfaz", value)}
                />}

                {!haySeleccion && data.HabilitarSenalPreEmision && data.ERROR_PRODUCT["seleccionoPreEmision"] == false && !haySeleccion ? <label className="error">{"Debe seleccionar al menos una señal de pre-emisión."}</label> : null}



            </div>

        </div>
    );
}

export default PreEmisionCabal;